export default __webpack_public_path__ + "static/media/132007456_150319209865007_2551240558218650741_n.becafd2e.jpg";